import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Link, withRouter } from 'react-router-dom'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import DateCell from '../../../elements/Table/Cells/DateCell'
import UpperCaseCell from '../../../elements/Table/Cells/UpperCaseCell'
import { moneyColumn, numVal } from '../../../modules/Utils'

function List (props) {
  const { list, fetch, fetching, company, onChangeCompany } = props

  const columns = [
    {
      Header: 'System ID',
      accessor: '_key',
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/people/payrollClaims/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    { Header: 'Process Date', accessor: 'date', Cell: DateCell },
    { Header: 'Due Date', accessor: 'due', Cell: DateCell },
    { Header: 'Type', accessor: 'type', Cell: UpperCaseCell },
    { Header: 'Currency', accessor: 'currency' },
    {
      Header: 'Amount',
      accessor: 'amount',
      Cell: ({ value }) => moneyColumn(numVal({ value }, 'value')),
      style: { textAlign: 'right' },
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      hideable: true,
      hideDefault: true,
    },
    { Header: 'Status', accessor: 'status', Cell: StatusCell },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default withRouter(List)
